import type { ReactNode } from 'react'

/** Label/value row shared by every summary popover. */
export function SummaryRow({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex items-baseline justify-between gap-4 text-sm">
      <span className="text-ink-400 shrink-0">{label}</span>
      <span className="text-foreground min-w-0 text-right break-words">{value || '-'}</span>
    </div>
  )
}

/** Bulleted list of names (drivers, trucks, commodities), with an empty note. */
export function SummaryList({ items, empty }: { items: string[]; empty: string }) {
  if (items.length === 0) {
    return <p className="text-ink-400 text-sm">{empty}</p>
  }
  return (
    <ul className="flex flex-col gap-1 text-sm">
      {items.map((item, i) => (
        <li key={`${item}-${i}`} className="text-foreground truncate">
          {item}
        </li>
      ))}
    </ul>
  )
}

export function SummaryBody({ children }: { children: ReactNode }) {
  return <div className="mt-3 flex flex-col gap-2">{children}</div>
}
